export const gamesImagesAssetsUrl: string = 'https://static-assets.lvbet.com/images/';
